import { PropsWithChildren } from 'react'
import { RouterProvider } from 'react-router'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'

import { RouterStoreProvier } from '../Store'
import { useRouterStore } from '../Store/hooks/useStore'

import { RouterProps } from './interface'

const RouterCore = () => {
  const router = useRouterStore(state => state.router)

  return <RouterProvider router={router} />
}

export const Router = ({
  /* -------------------------------------------------------------------------- */
  /*                          RouterStoreProvider Props                         */
  /* -------------------------------------------------------------------------- */
  basename,
  items,
  children
}: PropsWithChildren<RouterProps>) => {
  const loaded = useAuthStore(state => state.loaded)

  return (
    <RouterStoreProvier basename={basename} items={items}>
      {loaded !== false && <RouterCore />}
      {children}
    </RouterStoreProvier>
  )
}
